var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAmexCardIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 14,
    viewBox: "0 0 62 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.0741 7.71515L8.90892 2.35498L6.75694 7.71515H11.0741ZM31.8255 13.5155L31.8123 2.98843L27.2285 13.5155H24.456L19.8563 2.97769V13.5155H13.4294L12.2148 10.5174H5.6321L4.40428 13.5155H0.97168L6.63284 0.0734863H11.3276L16.7036 12.8015V0.0734863H21.863L26.0007 9.19141L29.8003 0.0734863H35.0654V13.5155H31.8255ZM40.0981 10.767V8.09093H47.0372V5.34777H40.0981V2.90254H48.0221L51.4811 6.82134L47.869 10.767H40.0981ZM61.5149 13.5692H57.4063L53.5143 9.11626L49.4691 13.5692H36.948V0.121799H49.6619L53.5513 4.52911L57.5727 0.121799H61.7024L55.558 6.8455L61.5149 13.5692Z",
    fill: "#006BA6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAmexCardIcon);
export default __webpack_public_path__ + "static/media/amexCardIcon.f7a80dfde653c396f9c70090293f9f15.svg";
export { ForwardRef as ReactComponent };